module.exports = __webpack_public_path__ + "static/media/sortMobile.16bfd11b.svg";